import { render, staticRenderFns } from "./ProductCategorySelectModal.vue?vue&type=template&id=8bf823b2&scoped=true&"
import script from "./ProductCategorySelectModal.vue?vue&type=script&lang=js&"
export * from "./ProductCategorySelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf823b2",
  null
  
)

export default component.exports